










import Vue from 'vue';
import { ExternalClient } from '@/types';

export default Vue.extend({
  props: {
    externalClient: {
      type: Object as () => ExternalClient,
      required: true,
    },
  },
});
